export interface LanguageViewModel {
  code: LanguageCode;
  locale: string,
  currency: string;
  displayedName: string;
}

export enum LanguageCode {
  PL = 'pl',
  EN = 'en',
  PT = 'pt',
}
